<template>
  <v-app>
    <component :is="layout"></component>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex';

import LoadingLayout from './layouts/LoadingLayout.vue';
import LoginLayout from './layouts/LoginLayout.vue';
import MainLayout from './layouts/MainLayout.vue';

export default {
  name: 'App',

  data: () => ({
    loading: false
  }),

  computed:{
    layout(){
      return this.loading ? 'LoadingLayout' : this.$store.getters.user ? 'MainLayout' : 'LoginLayout'
    }
  },

  methods:{
    ...mapActions(['check_local_storage'])
  },

  async mounted(){
    this.loading = true;
    await this.check_local_storage()
    this.loading = false;
  },

  components:{
    LoadingLayout,
    LoginLayout,
    MainLayout
  }
};
</script>
